module.exports = __webpack_public_path__ + "img/icon16-call-out-danger.b969cb13.svg";